import { useKeycloak } from "@react-keycloak/web";
import { useEffect, useState } from "react";
import { VerticalTimelineElement } from "react-vertical-timeline-component";
import { Button, Card, Col, Media, Row } from "reactstrap";
import pdfLogo from "../../../../assets/images/logo/pdfImage.png";
import { CourseDto } from "../../../../models/courseDto";
import { TypeCourse } from "../../../../models/typeCourseDto";
import hasRoles from "../../../../security/hasRoles";
import { useHttpClient } from "../../../../security/hooks/axiosProvider";
import styles from "./course.module.scss";
import { translate } from "react-switch-lang";

const CoursesTimeLine: React.FC<{ course: CourseDto; getCourseTimeString: any; getStepIcon: any; handleClickOpenModalViewer: any;t: (key: string) => string }> = ({
  course,
  getCourseTimeString,
  getStepIcon,
  handleClickOpenModalViewer,
  t
}) => {
  const { keycloak } = useKeycloak();
  const hasRoleAdmin = hasRoles(["ROLE_ELEARNING_ADMIN"], keycloak);
  const httpClient = useHttpClient(keycloak.authenticated);
  const [isCourseFinished, setIsCourseFinished] = useState(false);

  useEffect(() => {
    async function fetch() {
      getCourseStatus();
    }
    fetch();
    // eslint-disable-next-line
  }, [isCourseFinished]);

  async function getCourseStatus() {
    if (course && course.id) {
      const response = await httpClient.current.get(`/course/isCourseFinished/${course.id}`);
      setIsCourseFinished(response.data);
    }
  }

  return (
    <>
      <VerticalTimelineElement
        className={styles["timeline_element"]}
        contentStyle={{ padding: "0px", borderRaduis: "10px" }}
        key={course.id}
        animate={true}
        date={getCourseTimeString(course.courseHours, course.courseMinutes)}
        icon={getStepIcon(TypeCourse[course.courseType])}
      >
        <Card className={styles["course_box"]}>
          <div className="product-box">
            <div className="product-img">
              {course.courseType === "PDF" && (
                <Col>
                  <Row className={styles["pdf_course_title"]}>
                    <h5 className="vertical-timeline-element-subtitle">{course.title}</h5>
                  </Row>
                  <Row className={styles["pdf_container"]}>
                    <Media body src={pdfLogo} className={styles["pdf_logo"]} />
                  </Row>
                  
                </Col>                
              )}
              {course.courseType === "VIDEO" && (
                <Col>
                  <Row className={styles["embed-responsive embed-responsive-21by9"]}>
                    <h5 className="vertical-timeline-element-subtitle">{course.title}</h5>
                  </Row>
                  <div className={styles["video_thumbnail"]}>
                  <video width="100%" height="400px" controls>
                     <source src={course?.supportUrl + "/download"} type="video/mp4" />
                  </video>                  </div>
                </Col>
              )}
              <div className="product-hover">
                    <Button
                      className={styles["support_button"]}
                      onClick={() => {
                        handleClickOpenModalViewer(course);
                      }}
                    >
                      {hasRoleAdmin || isCourseFinished ? t("view_the_document") : t("training_path_start")}
                    </Button>
                  </div>
            </div>
          </div>
        </Card>
      </VerticalTimelineElement>
  
    </>
  );
};

export default translate(CoursesTimeLine);
